<p-dialog
  data-testid="vendor-sku-dialog"
  [visible]="visible"
  [header]="dialogTitle"
  [modal]="true"
  [style]="{ width: '600px', maxWidth: '90vw' }"
  [appendTo]="'body'"
  [showHeader]="true"
  (onHide)="onDialogHide()"
  [closable]="true"
  styleClass="vendor-sku-dialog"
>
  <div class="vendor-sku-form-dialog p-1">
    @if (form) {
      <form data-testid="vendor-sku-dialog-form" [formGroup]="form" class="space-y-4">
        @for (field of formFields; track field.key) {
          <div class="w-full">
            @if (field.type === "select" && field.key === "skuCode") {
              <!-- SKU Code Select (only in add mode) -->
              <label
                [for]="field.key"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                {{ field.label | translate }}
                @if (field.required) {
                  <span class="text-red-500">*</span>
                }
              </label>
              <div class="w-full" style="max-width: 100%">
                <app-paginated-select
                  [attr.data-testid]="'vendor-sku-dialog-select-' + field.key"
                  formControlName="skuCode"
                  [paginatedOptions]="skuPaginatedConfig"
                  [inputId]="field.key"
                  [showClear]="field.showClear ?? true"
                  [placeholder]="field.placeholder | translate"
                  styleClass="w-full"
                  panelStyleClass="vendor-sku-dropdown"
                  [appendTo]="null"
                  [invalid]="!!getFieldError(field.key)"
                ></app-paginated-select>
              </div>
              @if (getFieldError(field.key)) {
                <p class="text-red-500 text-xs mt-1">
                  {{ getFieldError(field.key) }}
                </p>
              }
            } @else if (field.type === "text") {
              <!-- Text Input -->
              <label
                [for]="field.key"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                {{ field.label | translate }}
                @if (field.required) {
                  <span class="text-red-500">*</span>
                }
              </label>
              <input
                [attr.data-testid]="'vendor-sku-dialog-input-' + field.key"
                pInputText
                [formControlName]="field.key"
                [id]="field.key"
                type="text"
                [placeholder]="field.placeholder | translate"
                class="w-full"
                [class.p-invalid]="getFieldError(field.key)"
              />
              @if (getFieldError(field.key)) {
                <p class="text-red-500 text-xs mt-1">
                  {{ getFieldError(field.key) }}
                </p>
              }
            } @else if (field.type === "textarea") {
              <!-- Textarea -->
              <label
                [for]="field.key"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                {{ field.label | translate }}
                @if (field.required) {
                  <span class="text-red-500">*</span>
                }
              </label>
              <textarea
                [attr.data-testid]="'vendor-sku-dialog-input-' + field.key"
                pInputTextarea
                [formControlName]="field.key"
                [id]="field.key"
                [rows]="field.rows || 3"
                [placeholder]="field.placeholder | translate"
                class="w-full"
                [class.p-invalid]="getFieldError(field.key)"
              ></textarea>
              @if (getFieldError(field.key)) {
                <p class="text-red-500 text-xs mt-1">
                  {{ getFieldError(field.key) }}
                </p>
              }
            } @else if (field.type === "number") {
              <label
                [for]="field.key"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                {{ field.label | translate }}
                @if (field.required) {
                  <span class="text-red-500">*</span>
                }
              </label>
              <p-inputNumber
                [attr.data-testid]="'vendor-sku-dialog-input-' + field.key"
                [formControlName]="field.key"
                [inputId]="field.key"
                [min]="field.min ?? 1"
                [useGrouping]="true"
                mode="decimal"
                [minFractionDigits]="0"
                [maxFractionDigits]="0"
                styleClass="w-full"
                inputStyleClass="w-full"
                [placeholder]="field.placeholder | translate"
                [class.ng-invalid]="!!getFieldError(field.key)"
                [class.ng-dirty]="!!getFieldError(field.key)"
              ></p-inputNumber>
              @if (getFieldError(field.key)) {
                <p class="text-red-500 text-xs mt-1">
                  {{ getFieldError(field.key) }}
                </p>
              }
            } @else if (field.type === "checkbox") {
              <div class="flex items-center gap-2 pt-1">
                <p-checkbox
                  [attr.data-testid]="'vendor-sku-dialog-checkbox-' + field.key"
                  [formControlName]="field.key"
                  [binary]="true"
                  [inputId]="field.key"
                ></p-checkbox>
                <label
                  [for]="field.key"
                  class="text-sm font-medium text-gray-700 cursor-pointer"
                >
                  {{ field.label | translate }}
                </label>
              </div>
              @if (field.key === "primaryFlag") {
                <p class="text-xs text-gray-500 mt-1">
                  {{ "vendor.manage_sku.form.primary_flag_hint" | translate }}
                </p>
              }
            }
          </div>
        }
      </form>
    }

    <!-- Border and Actions Section -->
    <div class="mt-8 pt-4 border-t border-gray-200">
      <!-- Error message -->
      @if (errorMessage()) {
        <div
          class="bg-red-50 border border-red-200 rounded p-3 text-sm text-red-600 mb-3"
        >
          {{ errorMessage() }}
        </div>
      }

      <!-- Actions -->
      <div class="flex justify-end gap-3">
        <app-button
          [testId]="'vendor-sku-dialog-cancel-btn'"
          [label]="'common.actions.cancel' | translate"
          type="secondary"
          [outlined]="true"
          (emitOnClick)="onCancel()"
          [disabled]="loading"
        ></app-button>
        <app-button
          [testId]="'vendor-sku-dialog-confirm-btn'"
          [label]="confirmButtonLabel"
          type="info"
          [loading]="loading"
          [disabled]="!form.valid || loading"
          (emitOnClick)="onConfirm()"
        ></app-button>
      </div>
    </div>
  </div>
</p-dialog>
